import styled from "styled-components";

export const StyledRightItem = styled.div`
  margin-right: ${({ theme }) => theme.space[1]};
  margin-bottom: ${({ theme }) => theme.space[1]};
`;
